export const COOKIE_MAX_AGE = 60 * 60 * 24; // 1 day
export const COOKIE_NAME = "fabrio-client-session";

export const PROMPT_BEFORE_IDLE = 1000 * 20; // 20 sec
export const IDLE_TIMEOUT = 1000 * 60 * 20 + PROMPT_BEFORE_IDLE; // 20 min + prompt time

export interface SessionData {
  userName: string;
  accessToken: string;
  userType: string;
  partyCode: string;
  isLoggedIn: boolean;
}

export const defaultSession: SessionData = {
  userName: "",
  accessToken: "",
  userType: "",
  partyCode: "",
  isLoggedIn: false,
};
